import { KeysToCamelCase, CycleWithRels } from '@statsbomb/parachute-types';
import { Atom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { competitionOptionsAtom, selectedCompetitionsAtom } from '@/atoms/filters/highLevel/competitions';
import { useGetFilteredOptions } from '@/hooks/useGetFilteredOptions';
import { GamesFilterType } from '@/hooks/useGetGamesByFilter';
import { FormattedGame } from '@/types/game';
import { NumberOption } from '@/types/generic';
import { getDistinctOrderedCompetitionOptions } from '@/utils/cycles';
import { RadarFilterSummaryItem } from './RadarFilterSummaryItem';

export const RadarFilterCompetitionSummary = ({
  filteredGamesDataAtom,
  selectedGamesAtom,
  orderedCyclesAtom,
}: {
  orderedCyclesAtom: Atom<Promise<KeysToCamelCase<CycleWithRels>[]>>;
  filteredGamesDataAtom: Atom<Promise<FormattedGame[]>>;
  selectedGamesAtom: Atom<Promise<NumberOption[]>>;
}) => {
  const { t } = useTranslation('entity');
  const orderedCycles = useAtomValue(orderedCyclesAtom);

  const filteredCompetitionOptions = useGetFilteredOptions(
    competitionOptionsAtom,
    filteredGamesDataAtom,
    selectedGamesAtom,
    GamesFilterType.COMPETITION,
  );

  const sortedCompetitionOptions = getDistinctOrderedCompetitionOptions(orderedCycles, filteredCompetitionOptions);

  return (
    <RadarFilterSummaryItem
      label={t('competition_one')}
      options={sortedCompetitionOptions}
      selectedOptions={useAtomValue(selectedCompetitionsAtom)}
      showFlags
    />
  );
};
